import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Component, forwardRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PostingService } from 'app/core/services/posting.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auto-complete-denial-code',
  templateUrl: './auto-complete-denial-code.component.html',
  styleUrls: ['./auto-complete-denial-code.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutoCompleteDenialCodeComponent),
      multi: true,
    }
  ],
})
export class AutoCompleteDenialCodeComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @ViewChild('denialCodeModal') denialCodeModal: T2CardComponent;

  denialCodeForm: FormGroup;
  subscriptions: Subscription[] = [];
  arrayCodeFilter = [];
  searchFilterCode = [];
  showList: boolean;
  onChangeFn = (_: any) => { };

  constructor(private fb: FormBuilder, private postingService: PostingService) {
    this.initForm();
  }

  ngOnInit() {
    this.observables();
  }

  initForm() {
    this.denialCodeForm = this.fb.group({
      denialcode: ['', Validators.required]
    });
  }

  observables() {
    this.subscriptions.push(
      this.denialCodeForm.valueChanges.subscribe((val) => {
        if (val) {
          this.onChangeFn(val.denialcode);
        }
      })
    );

    this.subscriptions.push(
      this.postingService.closeModal.subscribe((val) => {
        if (val) {
          this.denialCodeModal.close();
          this.showList = false;
        }
      })
    );
  }

  onAutoComplete(val) {
    if (val) {
      this.postingService.autoCompleteDenialCode({ filter: val }).subscribe((resp) => {
        if (resp) {
          this.showList = true;
          this.searchFilterCode = resp;
          this.arrayCodeFilter = [];
          this.arrayCodeFilter = this.autocompleteMatch(val.toUpperCase());
        }
      });
    } else {
      this.arrayCodeFilter = [];
    }
  }

  autocompleteMatch(input) {
    if (input === '') {
      return [];
    }
    const reg = new RegExp(input);
    return this.searchFilterCode.filter((item) => {
      if (item.denialcode.match(reg)) {
        return item;
      }
    });
  }

  onChangeDenial(denialcode) {
    if (denialcode) {
      this.denialCodeForm.patchValue({ denialcode: denialcode });
      this.showList = false;
    }
  }

  onShowDenialCodeModal() {
    const denialCode = this.denialCodeForm.get('denialcode').value;
    if (denialCode) {
      this.postingService.denialCode$.next({ code: denialCode, type: 'setCode' });
      this.denialCodeModal.open();
    }
  }

  writeValue(value: any): void {
    this.denialCodeForm.patchValue({ denialcode: value });
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(): void { }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.denialCodeForm.controls['denialcode'].disable();
    } else {
      this.denialCodeForm.controls['denialcode'].enable();
    }
   }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscribe: Subscription) => subscribe.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/auto-complete-denial-code/auto-complete-denial-code.component.ts